import { IEmployee, IEmployeeData } from '../employee.types';
import { Employee } from '../employee';
import { IEmployeePaginatedListData } from '@/services';

export const mockEmployeesData = (): IEmployeeData[] => [
  {
    id: 7,
    first_name: 'Christina',
    last_name: 'Galovic',
    employee_number: '143',
    is_active: true,
    title: '',
    supervisor: null,
    type: 1
  },
  {
    id: 4,
    first_name: 'Denis',
    last_name: 'Kan',
    employee_number: '113243',
    is_active: true,
    title: '',
    supervisor: null,
    type: 1
  }
];

export const mockEmployees = (
  data: IEmployeeData[] = mockEmployeesData()
): IEmployee[] => data.map(item => new Employee(item));

export const mockEmployeePaginatedData = (): IEmployeePaginatedListData => {
  return {
    count: mockEmployeesData().length,
    next: '',
    previous: '',
    results: mockEmployeesData()
  };
};
